import React, { useState } from "react";
import {
  BANNER_TABLE_PREVIEW_HEIGHT_PX,
  BANNER_TABLE_PREVIEW_WIDTH_PX,
} from "./bannerImageUtils";
import "./AcceptCurrentAsDefaultButton.css";

type Props = {
  currentBannerUrl: string;
  channelId: string;
  onAccept: (channelId: string) => void;
  accepting?: boolean;
};

const GHOST_FADE_MS = 350;
const GHOST_OPACITY_REST = 0;
const GHOST_OPACITY_HOVER = 0.5;

const AcceptCurrentAsDefaultButton: React.FC<Props> = ({
  currentBannerUrl,
  channelId,
  onAccept,
  accepting = false,
}) => {
  const [revealed, setRevealed] = useState(false);

  const ghostOpacity = revealed ? GHOST_OPACITY_HOVER : GHOST_OPACITY_REST;

  return (
    <button
      type="button"
      className="accept-current-default-btn"
      style={{
        width: BANNER_TABLE_PREVIEW_WIDTH_PX,
        height: BANNER_TABLE_PREVIEW_HEIGHT_PX,
        maxWidth: "100%",
        backgroundColor: revealed
          ? "rgba(255, 255, 255, 0.55)"
          : "rgba(249, 250, 251, 0.95)",
      }}
      onClick={() => onAccept(channelId)}
      disabled={accepting}
      onMouseEnter={() => setRevealed(true)}
      onMouseLeave={() => setRevealed(false)}
      onFocus={() => setRevealed(true)}
      onBlur={() => setRevealed(false)}
      title="Save the live banner as default only when it is full resolution (2048×1152+). YouTube preview images are too small for swap revert."
    >
      {currentBannerUrl ? (
        <img
          src={currentBannerUrl}
          alt=""
          aria-hidden
          className="accept-current-default-btn__ghost"
          style={{
            opacity: ghostOpacity,
            transition: `opacity ${GHOST_FADE_MS}ms ease-in-out`,
          }}
          loading="eager"
        />
      ) : null}

      <span
        className="accept-current-default-btn__label"
        style={{
          textShadow: revealed
            ? "0 1px 2px rgba(255, 255, 255, 0.9)"
            : undefined,
        }}
      >
        {accepting ? (
          <>
            <i className="pi pi-spin pi-spinner" aria-hidden />
            <span>Saving…</span>
          </>
        ) : (
          <>
            <i className="pi pi-check" aria-hidden />
            <span>Accept current as default</span>
          </>
        )}
      </span>
    </button>
  );
};

export default AcceptCurrentAsDefaultButton;
